import dayjs from 'dayjs';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
import urlHosts from '~/utils/hosts';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'default',
  data() {
    return {
      loaded: false,
      currentSweepStakes: []
    };
  },
  async fetch() {
    try {
      const res = await this.$axios(`${urlHosts[this.$config.environment]}/v1/experiences/giveaways`);
      this.currentSweepStakes = [...res.data.current_sweepstakes, ...(res.data.recent_sweepstakes || [])];
    } catch (err) {
      this.$sentry.captureException(err);
    }
  },
  head() {
    return generateMetaHead({
      title: 'Giveaways | Extra',
      description: 'Ready to enter a giveaway, but want to read the fine print? Check out our giveaway policies.'
    });
  },
  methods: {
    formatTitle(title, start, end) {
      const startFormatted = dayjs(start).format('MMM D, YYYY');
      const endFormatted = dayjs(end).format('MMM D, YYYY');
      return `${title} (${startFormatted} - ${endFormatted})`;
    }
  }
};